module.exports = __webpack_public_path__ + "img/light-bluearrow.ad2e4f20.svg";